/**
 * @desc Controller for the csGetStarted directive
 */
;(function () {
  'use strict'
  angular
    .module('contrast.get_started')
    .controller('csGetStartedCtrl', csGetStartedCtrl)

  function csGetStartedCtrl(permissions, allowedEntityService, UserService) {
    'ngInject'
    var vm = this

    angular.extend(vm, {
      finishedEntityCheck: false,
      hasAllowedEntity: undefined,
      entityType: 'application',
      checkSampleData: true,

      showArrow: hasPermission('EDIT'),
      hasPermission: hasPermission,
      setDirectiveProps: setDirectiveProps
    })

    function init() {
      if (vm.entityType === 'server') {
        if (
          vm.checkSampleData &&
          !angular.isUndefined(UserService.getSampleServerID())
        ) {
          vm.hasAllowedEntity = true
        } else {
          vm.hasAllowedEntity = allowedEntityService.hasAllowedServerCached()
          allowedEntityService
            .hasAllowedServer()
            .then(function (hasAllowedEntity) {
              vm.finishedEntityCheck = true
              vm.hasAllowedEntity = hasAllowedEntity
            })
        }
      } else {
        if (vm.entityType === 'sast-application' || vm.entityType === 'scans') {
          vm.finishedEntityCheck = true
          vm.hasAllowedEntity = true
        } else {
          if (
            vm.checkSampleData &&
            !angular.isUndefined(UserService.getSampleApplicationID())
          ) {
            vm.hasAllowedEntity = true
          } else {
            vm.hasAllowedEntity =
              allowedEntityService.hasAllowedApplicationCached()
            allowedEntityService
              .hasAllowedApplication()
              .then(function (hasAllowedEntity) {
                vm.finishedEntityCheck = true
                vm.hasAllowedEntity = hasAllowedEntity
              })
          }
        }
      }
    }

    function hasPermission(permission) {
      return permissions.hasPermission(permission)
    }

    function setDirectiveProps(type, checkSampleData) {
      vm.entityType = type
      vm.checkSampleData = checkSampleData
      init()
    }
  }
})()
